var React = require('react');

function ChevronSquareDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-23.51 194.43L241 361.94a24 24 0 0 1-33.94 0L71.52 226.43a24 24 0 0 1 0-33.94l17-17a24 24 0 0 1 33.94 0L224 277.09l101.57-101.58a24 24 0 0 1 33.95 0l17 17a24 24 0 0 1-.03 33.92z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M71.52 192.49l17-17a24 24 0 0 1 33.94 0L224 277.09l101.57-101.58a24 24 0 0 1 33.95 0l17 17a24 24 0 0 1 0 34L241 361.94a24 24 0 0 1-33.94 0L71.52 226.43a24 24 0 0 1 0-33.94z","className":"fa-primary","key":2})]);
}

ChevronSquareDown.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronSquareDown;

ChevronSquareDown.default = ChevronSquareDown;
